import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import Search from './Search';
import TableContent from './TableContent';
import { IAuthContext } from '../../context/auth/auth-context';
import withAuthContext from '../../context/auth/AuthConsumer';
import axios from 'axios';
import { API_BASE_URL } from '../../util/api.util';

const storeLink = 'https://storage.googleapis.com/ceres-maps/ceres_store/';

interface ISentiment {
  match: any;
}

const MainkWrapper = styled.div`
  overflow: auto;
  height: 100vh;
  padding: 0 5%;
  padding-top: 50px;
`;

const ResultsLead = styled.p`
  margin: 60px 0 0;
  text-align: center;
  font-size: 15px;
  color: #94a3b8;

  strong {
    color: #e2e8f0;
    font-weight: 600;
  }
`;

const Document = styled.div<{ $tone: 'positive' | 'negative' }>`
  max-width: 340px;
  margin: 1.25rem auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 126px;
  color: #f8fafc;
  font-size: clamp(1rem, 2vw, 1.35rem);
  padding: 1.25rem 1.5rem;
  border-radius: 16px;
  line-height: 1.35;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid
    ${(p) =>
      p.$tone === 'positive'
        ? 'rgba(52, 211, 153, 0.4)'
        : 'rgba(248, 113, 113, 0.4)'};
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(8px);
`;

const GifWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.15);
  background: rgba(10, 10, 12, 0.5);
`;

const Sentiment: React.FC<
  RouteComponentProps<any> &
  ISentiment & {
    context: IAuthContext;
  }
> = (props) => {
  const recordsNumShow = 10;
  const [queryText, setQueryText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [positiveData, setPositive] = useState<any>([]);
  const [negativeData, setNegative] = useState<any>([]);
  const GifPlayer = require('react-gif-player');

  const sentimentAnalyzer = (sort: any, from = 0, text = '') => {
    setIsLoading(true);

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      params: {
        action: 'search_doc',
        keyword: queryText || text,
        sorting: sort,
        records_num_show: recordsNumShow,
        records_num_from: from,
      },
    };
    axios
      .get(API_BASE_URL + '/SentimentAnalyzer', config)
      .then((response) => {
        response.data.sorting === 'doc_sentiment_score_avg-desc'
          ? setPositive(response.data)
          : setNegative(response.data);
        window.scrollBy(0, 100);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if(window.top !== window.self) {
      const query = new URLSearchParams(props.location.search);
      const rn: any = query.get('rn');
      setQueryText(rn);
      sentimentAnalyzer('doc_sentiment_score_avg-desc', 0, rn);
      sentimentAnalyzer('doc_sentiment_score_avg-asc', 0, rn);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainkWrapper>
      <Search sentimentAnalyzer={sentimentAnalyzer} setQueryText={setQueryText} isLoading={isLoading} queryText={queryText} />
      {(positiveData.total_records > 0 || negativeData.total_records > 0) && (
        <>
          <ResultsLead>
            Results found: <strong>{positiveData.total_records}</strong>
          </ResultsLead>
          <Row className="align-items-center">
            <Col md={5}>
              <Document $tone="positive">Most positive document</Document>
            </Col>
            <Col md={2}>
              <GifWrap>
                <GifPlayer
                  gif={storeLink + 'sentiment.gif'}
                  still={storeLink + 'sentiment.gif'}
                  autoplay={true}
                  width="100%"
                />
              </GifWrap>
            </Col>
            <Col md={5}>
              <Document $tone="negative">Most negative document</Document>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <TableContent
                environmenData={positiveData}
                queryText={queryText}
                sentimentAnalyzer={sentimentAnalyzer}
                setIsLoading={setIsLoading}
                tone="positive"
              />
            </Col>
            <Col>
              <TableContent
                environmenData={negativeData}
                queryText={queryText}
                sentimentAnalyzer={sentimentAnalyzer}
                setIsLoading={setIsLoading}
                tone="negative"
              />
            </Col>
          </Row>
        </>
      )}
    </MainkWrapper>
  );
};

export default withAuthContext(Sentiment);
